import React, { useEffect, useCallback } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import PropTypes from 'prop-types';

import AddressForm from 'components/Address/AddressForm';

const editAddressDefaultPropInitialValues = {};

const EditAddress = ({ initialValues = editAddressDefaultPropInitialValues, ...props }) => {
  const calledOnce = React.useRef(false);
  const form = useForm();

  const { setValue } = form;
  const setNewAddress = useCallback(() => {
    const addressFields = [
      'line1',
      'line2',
      'line3',
      'town',
      'region',
      'postalCode',
      'isContactAddress',
    ];
    addressFields.forEach(key => setValue(key, initialValues[key]));
  }, [initialValues, setValue]);

  useEffect(() => {
    if (!calledOnce.current) {
      Object.keys(initialValues).forEach(key => setValue(key, initialValues[key]));
      calledOnce.current = true;
    }

    if (initialValues.postalCode !== initialValues.control.postalCode) {
      setNewAddress();
    }
  }, [initialValues, setNewAddress, setValue]);

  return (
    <FormProvider {...form}>
      <AddressForm initialValues={initialValues} {...props} manualOnly />
    </FormProvider>
  );
};

EditAddress.propTypes = {
  initialValues: PropTypes.object,
};

export default EditAddress;
